<template>
  <div class="dashboard">
    <LdpThongke v-if="this.roles.includes('SystemAdmin')" />

    <div class="groupDashboard">
      <div
        class="card groupGrid groupGrid__left"
        v-if="this.roles.includes('SystemAdmin')"
      >
        <div class="card-header"><h3>Dòng họ theo khoảng đinh</h3></div>
        <PieChart />
      </div>

      <div
        class="card groupGrid groupGrid__right"
        v-if="
          this.roles.includes('SystemAdmin') ||
          this.roles.includes('ContentAdmin')
        "
      >
        <div class="card-header">
          <b-row>
            <b-col cols="12" md="5">
              <h3>Thống kê bài viết</h3>
            </b-col>
            <b-col cols="12" md="7">
              <div class="header-select">
                <!-- hiển thị theo tháng hoặc tuần -->
                <!-- <el-switch
                  style="display: block; width: 220px"
                  v-model="tuan"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  inactive-text="Tháng"
                  active-text="Tuần"
                >
                </el-switch> -->

                <div class="btnGroup">
                  <div
                    class="btnGroup__run"
                    :class="isThang ? 'btn-thang' : 'btn-tuan'"
                    id="btn-run"
                  ></div>
                  <div class="btnGroup__content">
                    <div class="btnGroup__item" @click="fn_selectThang()">
                      <p class="thang-item">Tháng</p>
                    </div>
                    <div class="btnGroup__item" @click="fn_selectTuan()">
                      <p class="tuan-item btn-disable">Tuần</p>
                    </div>
                  </div>
                </div>

                <!-- chọn tháng  -->
                <el-select
                  v-model="valueMonth"
                  placeholder="Chọn tháng"
                  style="width: 147px"
                  :disabled="isThang"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.valueMonth"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-if="loading == true" class="loading-data">
          <i class="fa-solid fa-rotate loading-icon"></i>
          Đang lấy dữ liệu
        </div>
        <BarChartBaiVietTuan
          v-if="isThang == false"
          :thang="valueMonth"
          @loadDone="loadDone"
        />
        <BarChartBaiVietThang v-if="isThang == true" @loadDone="loadDone" />
      </div>
    </div>
    <div v-if="this.roles.includes('SystemAdmin')" class="ttdk__dongHo">
      <TrangThaiDangKyDongHo />
    </div>
    <div
      v-if="
        this.roles.includes('SystemAdmin') ||
        this.roles.includes('ContentAdmin')
      "
    >
      <TrangThaiLoiNhan />
    </div>

    <div class="card" v-if="this.roles.includes('SystemAdmin')">
      <div class="card-header"><h3>Thời điểm đăng ký dòng họ</h3></div>
      <LineChart />
    </div>
  </div>
</template>

<script>
// import AreaChart from "../Chart/AreaChart.vue";
import LineChart from "../Chart/LineChart.vue";
import BarChartBaiVietTuan from "../Chart/BarChartBaiVietTuan.vue";
import BarChartBaiVietThang from "../Chart/BarChartBaiVietThang.vue";
import PieChart from "../Chart/PieChart.vue";
import LdpThongke from "../LdpThongke/LdpThongke.vue";
import TrangThaiDangKyDongHo from "./TrangThaiDangKyDongHo.vue";
import TrangThaiLoiNhan from "./TrangThaiLoiNhan.vue";
import MethodService from "../../../service/MethodService";
export default {
  name: "App",
  components: {
    // AreaChart,
    LineChart,
    BarChartBaiVietTuan,
    BarChartBaiVietThang,
    PieChart,
    LdpThongke,
    TrangThaiDangKyDongHo,
    TrangThaiLoiNhan,
  },
  methods: {
    loadDone() {
      this.loading = false;
    },
    async fn_getAccount() {
      this.currentUser = MethodService.getCurrentUser();
      this.roles = this.currentUser.roles;
    },
    fn_getMonth() {
      let toDay = new Date();
      this.valueMonth = "Tháng " + (toDay.getMonth() + 1).toString();
    },
    fn_selectThang() {
      this.loading = true;
      this.isThang = true;
      $(".thang-item").removeClass("btn-disable");
      $(".tuan-item").addClass("btn-disable");
    },
    fn_selectTuan() {
      this.loading = true;

      this.isThang = false;
      $(".tuan-item").removeClass("btn-disable");
      $(".thang-item").addClass("btn-disable");
    },
  },
  data() {
    return {
      loading: true,
      tuan: true,
      isThang: true,
      roles: [],
      options: [
        {
          value: "Tháng 1",
          label: "Tháng 1",
        },
        {
          value: "Tháng 2",
          label: "Tháng 2",
        },
        {
          value: "Tháng 3",
          label: "Tháng 3",
        },
        {
          value: "Tháng 4",
          label: "Tháng 4",
        },
        {
          value: "Tháng 5",
          label: "Tháng 5",
        },
        {
          value: "Tháng 6",
          label: "Tháng 6",
        },
        {
          value: "Tháng 7",
          label: "Tháng 7",
        },
        {
          value: "Tháng 8",
          label: "Tháng 8",
        },
        {
          value: "Tháng 9",
          label: "Tháng 9",
        },
        {
          value: "Tháng 10",
          label: "Tháng 10",
        },
        {
          value: "Tháng 11",
          label: "Tháng 11",
        },
        {
          value: "Tháng 12",
          label: "Tháng 12",
        },
      ],
      valueMonth: "",
    };
  },
  created() {
    this.fn_getMonth();
    this.fn_getAccount();
  },
};
</script>

<style lang="scss">
.card {
  box-shadow: 0 0.46875rem 2.1875rem #04091408, 0 0.9375rem 1.40625rem #04091408,
    0 0.25rem 0.53125rem #0409140d, 0 0.125rem 0.1875rem #04091408;
  border-width: 0;
  transition: all 0.2s;
  margin-bottom: 15px;
}
.card-header {
  padding: 15px 20px;
  margin-bottom: 0;
  color: inherit;
  background-color: #fff;
  border-bottom: 1px solid rgba(26, 54, 126, 0.125);
  text-transform: none;
}
.card-item {
  margin: 0 10px 0 0;
}
.row.no-gutters {
  margin-right: 0;
  margin-left: 0;

  & > [class^="col-"],
  & > [class*=" col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}

.groupGrid {
  &__left {
    width: 100%;
  }
  &__left,
  &__right {
    min-height: 490px;
  }
}

.header-select {
  display: flex;
  align-items: center;
  justify-content: end;
}
.ttdk__dongHo {
  width: 100%;
}

.btnGroup {
  position: relative;
  border-radius: 30px;
  height: 34px;
  width: 169px;
  box-shadow: 0 0.46875rem 2.1875rem #04091408, 0 0.9375rem 1.40625rem #04091408,
    0 0.25rem 0.53125rem #0409140d, 0 0.125rem 0.1875rem #04091408;
  margin-right: 15px;
  border: 1px solid #efefef;

  &__run {
    position: absolute;
    z-index: 1;
    background-color: rgb(204, 147, 147);
    width: 80px;
    height: 24px;
    border-radius: inherit;
    transition: 0.3s;
    top: 50%;
    left: 2px;
    transform: translateY(-50%);
  }
  &__content {
    position: absolute;
    cursor: pointer;
    z-index: 2;
    display: flex;
    width: 160px;
    justify-content: space-around;
    top: 50%;
    transform: translateY(-50%);
  }
  &__item p {
    color: #fff;
  }
}

.btn-disable {
  color: #a7a7a7 !important;
}
.btn-thang {
  left: 4px;
  background: #f56c6c;
}
.btn-tuan {
  left: 83px;
  background: #67c23a;
}

@media (min-width: 1025px) {
  .groupGrid {
    &__left {
      width: 35%;
      margin-right: 20px;
      float: left;
    }
  }
}
@media (min-width: 1350px) {
  .ttdk__dongHo {
    width: 58%;
    margin-right: 20px;
    float: left;
  }
}
.loading-data {
  position: absolute;
  top: 50%;
  left: 50%;
}
</style>
